export default "__VITE_ASSET__COPrFltG__"